/* Armora — floating pill header.

   Once the page scrolls past a small threshold the header detaches from the
   top edge and rounds into a pill. Only a class is toggled here; every visual
   value lives in armora-redesign.css, so the theme editor, app embeds and app
   blocks stay untouched.

   Reading the offset is deliberately defensive. Depending on the template this
   theme scrolls either the window or the <body> (html is height:100%, body is
   overflow-y:auto), and app drawers swap between the two at runtime. Rather
   than guess, take whichever source reports movement — including the body's
   own rect, which goes negative when the viewport is the scroller.

   Scroll events do not bubble, but a capture listener on document still sees
   them from any element, so one listener covers every possible container. */
(function () {
  'use strict';

  var THRESHOLD = 24;
  var CLASS = 'armora-stuck';

  function offset() {
    var rect = document.body.getBoundingClientRect().top;
    return Math.max(
      window.scrollY || 0,
      document.body.scrollTop || 0,
      document.documentElement.scrollTop || 0,
      rect < 0 ? -rect : 0
    );
  }

  function boot() {
    var section = document.querySelector('.section-header');
    if (!section) return;

    var stuck = null;
    var queued = false;

    function update() {
      queued = false;
      var next = offset() > THRESHOLD;
      if (next === stuck) return;
      stuck = next;
      section.classList.toggle(CLASS, next);
    }

    function onScroll() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('resize', function () { stuck = null; onScroll(); }, { passive: true });

    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
